import React from 'react';

import { Box } from '@mui/material';

interface Props {
    student: any;
}

const getInitials = (nameString) => {
    const names = nameString.split(' ');
    return names.length > 1
        ? `${names[0].charAt(0).toUpperCase()}${names[1].charAt(0).toUpperCase()}`
        : names[0].charAt(0).toUpperCase();
};

const UserImage: React.FC<Props> = ({ student }) => (
    <Box sx={{ position: 'relative', fontSize: '14px', borderRadius: '18px', color: 'rgb(255,255,255)' }}>
        {student.user_image && (
            <img
                src={student.user_image}
                style={{ display: 'inline-block', borderRadius: '6px', width: '24px', height: '24px' }}
            />
        )}
        {!student.user_image && (
            <div
                style={{
                    display: 'inline-block',
                    backgroundColor: '#4739e7',
                    borderRadius: '6px',
                    width: '24px',
                    height: '24px',
                    textAlign: 'center'
                }}
            >
                {getInitials(student.user_name)}
            </div>
        )}
    </Box>
);

export default UserImage;
